import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bml-product-features',
  templateUrl: './product-features.component.html',
  styleUrls: ['./product-features.component.scss']
})
export class ProductFeaturesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
